
<div class="availability-dialog">

  <!-- NUMERO REPERIBILITÀ -->
  <div class="availability-contact">
    <div class="availability-contact-info">

      <span class="availability-contact-label">
        Numero reperibilità
      </span>

      <a
        class="availability-phone"
        href="tel:+393534613879"
        aria-label="Chiama il numero di reperibilità 3534613879"
      >
        <i class="pi pi-phone"></i>
        <span>3534613879</span>
      </a>

    </div>
  </div>

  <!-- NESSUN PERIODO DISPONIBILE -->
  <div
    *ngIf="periods.length === 0"
    class="availability-empty"
  >
    <i class="pi pi-calendar-times"></i>

    <h3>Nessun turno programmato</h3>

    <p>
      Non sono presenti turni di reperibilità
      per il periodo corrente.
    </p>
  </div>

  <!-- PERIODI DISPONIBILI -->
  <ng-container *ngIf="periods.length > 0">

    <!-- NAVIGAZIONE SETTIMANALE -->
    <div class="availability-navigation">

      <button
        type="button"
        class="availability-nav-button"
        [disabled]="activeIndex === 0"
        (click)="previousPeriod()"
      >
        <i class="pi pi-arrow-left"></i>
        <span>Indietro</span>
      </button>

      <div class="availability-period-indicator">
        <span class="availability-period-label">
          Settimana {{ activeIndex + 1 }} di {{ periods.length }}
        </span>

        <strong class="availability-period-dates">
          {{ getWeekLabel(activeIndex) }}
        </strong>
      </div>

      <button
        type="button"
        class="availability-nav-button availability-nav-next"
        [disabled]="activeIndex === periods.length - 1"
        (click)="nextPeriod()"
      >
        <span>Avanti</span>
        <i class="pi pi-arrow-right"></i>
      </button>

    </div>

    <!-- TITOLO SEZIONE -->
    <div class="availability-section-title">
      <h3>Turni di reperibilità</h3>

      <p>
        Seleziona una giornata per visualizzare
        il reperibile e gli orari del servizio.
      </p>
    </div>

    <!-- ELENCO GIORNATE -->
    <p-accordion
      [multiple]="false"
      [activeIndex]="activeDay"
      styleClass="availability-accordion"
    >

      <ng-container
        *ngFor="
          let unit of periods[activeIndex].units;
          let index = index
        "
      >

        <p-accordionTab
          [disabled]="isDayDisabled(unit, index)"
          [ngClass]="{
            'accordion-tab-today': isToday(unit.unitDate),
            'accordion-tab-before': isPastDay(unit.unitDate),
            'accordion-tab-inactive': !unit.isActive
          }"
        >

          <!-- INTESTAZIONE GIORNATA -->
          <ng-template pTemplate="header">

            <div class="availability-day-header">

              <span class="availability-day-name">
                {{
                  unit.unitDate
                    | date: 'EEEE, dd MMMM yyyy' : '' : 'it'
                }}
              </span>

              <div class="availability-day-badges">

                <span
                  *ngIf="isToday(unit.unitDate)"
                  class="availability-badge availability-badge-today"
                >
                  Oggi
                </span>

                <span
                  *ngIf="!unit.isActive && !isPastDay(unit.unitDate)"
                  class="availability-badge availability-badge-inactive"
                >
                  Servizio non attivo
                </span>

              </div>

            </div>

          </ng-template>

          <!-- DETTAGLI REPERIBILITÀ -->
          <div class="availability-day-content">

            <ng-container
              *ngIf="
                unit.times && unit.times.length > 0;
                else noTimes
              "
            >

              <div
                *ngFor="
                  let time of unit.times;
                  let last = last
                "
                class="availability-shift"
                [class.availability-shift-last]="last"
              >

                <div class="availability-shift-person">
                  <span class="availability-field-label">
                    Reperibile
                  </span>

                  <strong class="availability-person-name">
                    {{ time.delegate }}
                  </strong>
                </div>

                <div class="availability-shift-hours">

                  <div class="availability-time">
                    <span class="availability-field-label">
                      Dalle ore
                    </span>

                    <strong>{{ time.startTime }}</strong>
                  </div>

                  <i class="pi pi-arrow-right availability-time-arrow"></i>

                  <div class="availability-time">
                    <span class="availability-field-label">
                      Alle ore
                    </span>

                    <strong>{{ time.endTime }}</strong>
                  </div>

                </div>

              </div>

            </ng-container>

            <ng-template #noTimes>
              <div class="availability-no-times">
                Nessun orario disponibile per questa giornata.
              </div>
            </ng-template>

          </div>

        </p-accordionTab>

      </ng-container>

    </p-accordion>

  </ng-container>

</div>
